import { NextI18NextRequest } from 'next-i18next';

const LOCALES: { [key: string]: string } = {
  sv: 'sv-SE',
  en: 'en-US',
  de: 'de-DE',
} as const;

const LANGUAGES = ['sv', 'en', 'de'];

export const getLocale = (req: NextI18NextRequest, asPath?: string) => {
  let language = 'en';
  if (req) {
    language = req.lng || 'en';
  } else if (asPath) {
    const urlParts = asPath?.split('/');
    if (urlParts.length > 1 && urlParts[1].length === 2 && LANGUAGES.includes(urlParts[1])) {
      language = urlParts[1];
    }
  }
  const locale = LOCALES[language];
  return locale;
};
